var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "boxicons:location-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 1.66667C6.325 1.66667 3.33333 4.65833 3.33333 8.33333C3.30833 13.7 9.26667 18 9.51667 18.1833C9.65833 18.2833 9.83333 18.3417 10 18.3417C10.1667 18.3417 10.3417 18.2917 10.4833 18.1833C10.7333 18 16.6917 13.7083 16.6667 8.33333C16.6667 4.65833 13.675 1.66667 10 1.66667ZM10 11.6667C8.15833 11.6667 6.66667 10.175 6.66667 8.33333C6.66667 6.49167 8.15833 5 10 5C11.8417 5 13.3333 6.49167 13.3333 8.33333C13.3333 10.175 11.8417 11.6667 10 11.6667Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.ec95538174f8bc186895f5b5880ad116.svg";
export { ForwardRef as ReactComponent };